module.exports = __webpack_public_path__ + "img/32.afb6aab8.jpg";